import { render } from "./03_Buildings.vue?vue&type=template&id=56b7b959&scoped=true"
import script from "./03_Buildings.vue?vue&type=script&lang=js"
export * from "./03_Buildings.vue?vue&type=script&lang=js"

import "./03_Buildings.vue?vue&type=style&index=0&id=56b7b959&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56b7b959"]])

export default __exports__